// puts the Symbol-keyed members on a prototype; IE 11 has no Symbol, and gets none
export default function addSymbolMembers(members, iterator, isConcatSpreadable) {
  if (isConcatSpreadable === void 0) {
    isConcatSpreadable = false;
  }
  if (typeof Symbol !== 'function') return;
  members[Symbol.iterator] = iterator;
  // a native concat spreads it as it spreads an array
  if (isConcatSpreadable) members[Symbol.isConcatSpreadable] = true;
}